<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>SIM Usage Details</h3>
        <button class="btn btn-secondary" (click)="goBack()">Back to SIM</button>
      </div>

      <!-- Loading indicator -->
      @if (loading) {
        <div class="d-flex justify-content-center mt-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }

      <!-- Error message -->
      @if (error && !loading) {
        <div class="alert alert-danger mt-3">
          {{ error }}
        </div>
      }

      <!-- Usage details -->
      @if (!loading && !error && usage) {
        <div class="card mt-4">
          <div class="card-body">
            <h5 class="card-title">Usage Information for ICCID: {{ iccid }}</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h6 class="card-title">Data Usage</h6>
                    @if (usage.data_used && usage.data_limit) {
                      <p class="card-text">
                        <strong>Used:</strong> {{ usage.data_used }} / {{ usage.data_limit }}
                      </p>
                    }
                    @if (!usage.data_used || !usage.data_limit) {
                      <p class="card-text">
                        Data usage information not available
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h6 class="card-title">Text Usage</h6>
                    @if (usage.text_used && usage.text_limit) {
                      <p class="card-text">
                        <strong>Used:</strong> {{ usage.text_used }} / {{ usage.text_limit }}
                      </p>
                    }
                    @if (!usage.text_used || !usage.text_limit) {
                      <p class="card-text">
                        Text usage information not available
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h6 class="card-title">Voice Usage</h6>
                    @if (usage.voice_used && usage.voice_limit) {
                      <p class="card-text">
                        <strong>Used:</strong> {{ usage.voice_used }} / {{ usage.voice_limit }}
                      </p>
                    }
                    @if (!usage.voice_used || !usage.voice_limit) {
                      <p class="card-text">
                        Voice usage information not available
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h6 class="card-title">Status Information</h6>
                    @if (usage.status) {
                      <p class="card-text">
                        <strong>Status:</strong> {{ usage.status }}
                      </p>
                    }
                    @if (usage.last_updated) {
                      <p class="card-text">
                        <strong>Last Updated:</strong> {{ formatDate(usage.last_updated) }}
                      </p>
                    }
                    @if (!usage.status && !usage.last_updated) {
                      <p class="card-text">
                        Status information not available
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- No usage message -->
      @if (!loading && !error && !usage) {
        <div class="alert alert-info mt-3">
          Usage data not available for this SIM.
        </div>
      }
    </div>
  </div>
</div>